import { UTM_COOKIE_NAME } from "@/constants/utm";
import type { UtmData } from "@/types/utm";

/** Parse the UTM cookie out of a Cookie header string. Returns null when absent. */
export function parseUtmCookieString(cookieHeader: string): UtmData | null {
  const match = cookieHeader.match(new RegExp(`(?:^|;\\s*)${UTM_COOKIE_NAME}=([^;]+)`));
  if (!match?.[1]) return null;
  return JSON.parse(decodeURIComponent(match[1])) as UtmData;
}
